// v3.21-1670 · FundedRoute — route guard for /funded.
//
// Defense-in-depth companion to the backend `require_funded_access`
// SSOT (services/funded_capability.py).  A user is authorised iff
// their canonical account email ends EXACTLY with
// `@prestigioustravelclub.org`.  No role interpretation, no
// specific-user grants.  Impersonation ("View As") is honoured via
// effectiveUser.  Users who fail the check are silently redirected
// to /clients.
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { canAccessFunded } from '../lib/canAccessFunded';

const FundedRoute = ({ children, fallback = '/clients' }) => {
  const { user, effectiveUser, loading, authChecked } = useAuth();
  if (loading || (!user && !authChecked)) return null;
  const target = effectiveUser || user;
  if (!canAccessFunded(target)) {
    return <Navigate to={fallback} replace />;
  }
  return children;
};

export default FundedRoute;
